import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '@/components/ui/tooltip';
import { Card } from '../../../../@types/Checkout.type';
import { capitalizeFirstLetter } from '../../../../shared/utils/general.util';
import { getBrandIcon } from '../../../../shared/utils/payments.util';
import { Info } from '@phosphor-icons/react';
import Text from '../../../atoms/Text';

export const CardInfo: React.FC<{
	card: Card;
	hideExpireDate?: boolean;
	infoMessage?: string;
}> = ({ card, hideExpireDate, infoMessage }) => {
	return (
		<div className='flex flex-row items-center justify-between gap-2 w-full'>
			<div className='inline-flex items-center gap-x-1 justify-center'>
				<img
					src={getBrandIcon(card.details.brand)}
					alt='brand'
					className='w-[32px] h-[32px]'
				/>
				<span className='text-sm font-bold inline-flex text-h-neutral-30'>
					<span className='hidden md:block mr-1 text-h-neutral-30'>
						{capitalizeFirstLetter(
							card.details.brand === 'amex'
								? 'American Express'
								: card.details.brand,
						)}{' '}
					</span>
					**** {card.details?.last_four || ''}
				</span>
				{infoMessage && (
					<TooltipProvider>
						<Tooltip>
							<TooltipTrigger asChild>
								<span className='inline-flex'>
									<Info
										className='ml-4 inline-block'
										weight='bold'
									/>
								</span>
							</TooltipTrigger>
							<TooltipContent>
								<p>{infoMessage}</p>
							</TooltipContent>
						</Tooltip>
					</TooltipProvider>
				)}
			</div>

			{!hideExpireDate && (
				<div>
					<Text
						size='m'
						sx='hidden md:block'
						color='medium'
					>
						Vence el {card.details.expires}
					</Text>
					<Text
						size='m'
						sx='block md:hidden'
						color='medium'
					>
						{card.details.expires}
					</Text>
				</div>
			)}
		</div>
	);
};
